import WorkExperience from '@/models/WorkExperience';

const GET_WORK_EXPERIENCE = 'get_work_experience';
const GET_WORK_EXPERIENCE_REQUEST = 'get_work_experience_request';
const GET_WORK_EXPERIENCE_SUCCESS = 'get_work_experience_success';
const GET_WORK_EXPERIENCE_ERROR = 'get_work_experience_error';

export { GET_WORK_EXPERIENCE };

export default {
    state: {
        work_experience: [],
        loading: false,
        work_experience_errors: [],
    },
    mutations: {
        [GET_WORK_EXPERIENCE_REQUEST]: (state) => {
            state.work_experience = [];
            state.loading = true;
            state.work_experience_errors = [];
        },
        [GET_WORK_EXPERIENCE_SUCCESS]: (state, { work_experience }) => {
            state.work_experience = work_experience;
            state.loading = false;
            state.work_experience_errors = [];
        },
        [GET_WORK_EXPERIENCE_ERROR]: (state, { errors }) => {
            state.work_experience = [];
            state.loading = false;
            state.work_experience_errors = errors;
        },
    },
    actions: {
        [GET_WORK_EXPERIENCE]: ({ commit, rootState }, { clientId, params = {} }) => {
            if (!clientId) {
                clientId = rootState.trajectory.trajectory.client.id;
            }
            commit(GET_WORK_EXPERIENCE_REQUEST);
            return new Promise((resolve, reject) => {
                const ClientWorkExperience = WorkExperience.makeModel(`/clients/${clientId}/experience`);
                ClientWorkExperience.collection(params)
                    .then(({items, meta}) => {
                        const work_experience = items;
                        commit(GET_WORK_EXPERIENCE_SUCCESS, { work_experience });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_WORK_EXPERIENCE_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/work-experience.js